import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"
import { useProductFilters } from "@nosto/preact"
import { useState } from "preact/hooks"
import Checkbox from "./elements/Checkbox"
import Icon from "./elements/Icon"

export default function Facet({ facet }) {
    const { selectedFiltersCount, toggleActive, toggleProductFilter } = useFacet(facet)
    const { filters, removeAll } = useProductFilters()
    const [active, setActive] = useState(true)

    const removeFilterGroupHandler = (group) => {
        filters.filter(filter => filter.name === group).map(filter => filter.remove())
    }

    return (
        <li class={`ns-sidebar-dropdown ns-facet-dropdown-container ${active ? "ns-active" : ""}`}>
            <a
                class="ns-facet-link"
                href="javascript:void(0)"
                data-nosto-element="facet"
                onClick={()=>{setActive(!active)}}
            >
                <span class="ns-facet-name">
                    <svg class="ns-facet-name-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="currentColor" d="m7 14l5-5l5 5z" /></svg>
                    {facet.name}
                </span>
                {selectedFiltersCount > 0 && (
                    <a
                        href="javascript:void(0)"
                        class="ns-clear-facet-text"
                        onClick={(event) => {event.stopPropagation(); removeFilterGroupHandler(facet.name)}}
                    >
                        Clear
                    </a>
                )}
            </a>
            <div class="ns-sidebar-submenu">
                {facet.name === 'Colour' 
                ?
                <ul class="ns-facet-list ns-color-list">
                    {facet.data?.map(value => (
                        <li
                            class={value.selected ? "ns-facet-option-selected ns-selected-color-option ns-color-option": "ns-facet-option ns-color-option"}
                            data-nosto-element="facet-setting"
                            style={`background: ${value.value}`}
                            title={value.value.toUpperCase()}
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                        </li>
                    ))}
                </ul>
                :            
                <ul class="ns-facet-list">
                    {facet.data?.map(value => (
                        <li
                            class={value.selected ? "ns-facet-option-selected": "ns-facet-option"}
                            data-nosto-element="facet-setting"
                        >
                            <Checkbox
                                value={value.value}
                                selected={value.selected}
                                onChange={e => {
                                    e.preventDefault()
                                    toggleProductFilter(facet.field, value.value, !value.selected)
                                }}
                            />
                            <span class="ns-count ns-facet-option-count">
                                ({value.count})
                            </span>
                        </li>
                    ))}
                </ul>
                }
            </div>
        </li>
    )
}
